import { defineMessages } from "react-intl";

export const orderPaymentMessages = defineMessages({
  clickAndCollectShippingMethod: {
    id: "ghGLbJ",
    defaultMessage: "click&collect",
    description: "OrderPayment click&collect shipping method",
  },
  shippingDoesNotApply: {
    id: "uzAPCt",
    defaultMessage: "does not apply",
    description: "OrderPayment does not require shipping",
  },
  paymentTitle: {
    id: "7KRGqz",
    defaultMessage: "Payment balance",
    description: "Payment card title",
  },
  subtotal: {
    id: "T8rvXs",
    defaultMessage: "Subtotal",
    description: "order subtotal price",
  },
  itemCount: {
    id: "pr513b",
    defaultMessage: "{quantity} items",
    description: "ordered products",
  },
  taxes: {
    id: "r+dgiv",
    defaultMessage: "Taxes",
  },
  vatIncluded: {
    id: "dJVXIb",
    defaultMessage: "VAT included",
    description: "vat included in order price",
  },
  vatNotIncluded: {
    id: "5Jo3C5",
    defaultMessage: "does not apply",
    description: "vat not included in order price",
  },
  shipping: {
    id: "+CeEe3",
    defaultMessage: "Shipping",
    description: "order shipping method name",
  },
  shippingNotApplicable: {
    id: "Rsknyh",
    defaultMessage: "does not apply",
    description: "order does not require shipping",
  },
  discount: {
    id: "u0S2be",
    defaultMessage: "Discount",
    description: "order discount",
  },
  total: {
    id: "zb4eBO",
    defaultMessage: "Total",
    description: "order total price",
  },
  preauthorized: {
    id: "uUsZ7m",
    defaultMessage: "Preauthorized amount",
    description: "order payment",
  },
  captured: {
    id: "V+gwx7",
    defaultMessage: "Captured amount",
    description: "order payment",
  },
  refunded: {
    id: "q+gCyP",
    defaultMessage: "Refunded amount",
    description: "order payment",
  },
  outstanding: {
    id: "5te3Tp",
    defaultMessage: "Outstanding Balance",
    description: "order payment",
  },
  paidWithGiftCard: {
    id: "yivxZJ",
    defaultMessage: "Paid with Gift Card: ({link})",
    description: "order payment",
  },
  includedInSubtotal: {
    id: "pPef6L",
    defaultMessage: "Included in subtotal",
    description: "order payment",
  },
  includedInPrices: {
    id: "ukYopn",
    defaultMessage: "Included in prices",
    description: "order payment",
  },
  settled: {
    id: "Sxzua5",
    defaultMessage: "Settled",
    description: "order payment",
  },
});

export const paymentButtonMessages = defineMessages({
  capture: {
    id: "BZ7BkQ",
    defaultMessage: "Capture",
    description: "capture payment, button",
  },
  refund: {
    id: "HaQ8cg",
    defaultMessage: "Refund",
    description: "button",
  },
  void: {
    id: "HaQ8cg",
    defaultMessage: "Refund",
    description: "button",
  },
  markAsPaid: {
    id: "+5HkZN",
    defaultMessage: "Mark as paid",
    description: "order, button",
  },
});
